import clsx from 'clsx'

import { CellSchema } from '../module'
import s from '../styles.module.scss'

export const SeatFree = ({ seat, isClicked, onClick }: CellSchema) => {
  return (
    <div
      onClick={() => onClick?.(seat)}
      className={clsx(
        s.container,
        isClicked ? s.clickedContainer : s.freeContainer,
      )}
    >
      <div className={clsx('medium-18', s.free)}>{seat}</div>
    </div>
  )
}
